"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabGroup = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var TabGroupItem_1 = require("./TabGroupItem");
var components_1 = require("./components");
var utilities_1 = require("../../utilities");
var TabGroup = function (_a) {
    var action = _a.action, children = _a.children, className = _a.className, dark = _a.dark, _b = _a.divider, divider = _b === void 0 ? true : _b, fitted = _a.fitted, _c = _a.size, size = _c === void 0 ? 'normal' : _c, maxWidth = _a.maxWidth, verticallyDivided = _a.verticallyDivided, _d = _a.type, type = _d === void 0 ? 'underline' : _d, _e = _a.textAlign, textAlign = _e === void 0 ? 'center' : _e, props = __rest(_a, ["action", "children", "className", "dark", "divider", "fitted", "size", "maxWidth", "verticallyDivided", "type", "textAlign"]);
    var TabGroupClasses = classnames_1.default('TabGroup', className, {
        'TabGroup--fitted': fitted,
        'TabGroup--dark': dark,
        'TabGroup--index': type === 'index',
        'TabGroup--underline': type === 'underline',
        'TabGroup--leftAlign': textAlign === 'left',
        'TabGroup--large': size === 'large',
        'TabGroup--divider': divider,
        'TabGroup--maxWidth': maxWidth,
        'TabGroup--verticallyDivided': verticallyDivided,
    });
    return (react_1.default.createElement("ul", __assign({ role: "tablist", className: TabGroupClasses }, props),
        utilities_1.wrapChildren(children, TabGroupItem_1.TabGroupItem),
        action && react_1.default.createElement(components_1.TabAction, null, action)));
};
exports.TabGroup = TabGroup;
exports.TabGroup.Action = components_1.TabAction;
//# sourceMappingURL=TabGroup.js.map